var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(hasParticipated){ 
__p+='\n  <a class="btn full-width" href="#comments">'+
((__t=( t('Common', 'surveyParticipation.footer.actions.joinDiscussion') ))==null?'':_.escape(__t))+
'</a>\n';
 } else { 
__p+='\n  ';
 var isLast = current + 1 === form.items.length 
__p+='\n  ';
 var nextLabel = isLast ? t('Common', 'surveyParticipation.footer.actions.submit') : t('Common', 'surveyParticipation.footer.actions.next') 
__p+='\n  ';
 var nextClass = isLast ? 'js-survey-submit' : 'js-item-next' 
__p+='\n  <div class="survey-footer__actions">\n    <div class="btn btn--survey-prev js-item-prev ';
 if(current === 0){
__p+='is-hidden';
}
__p+='">'+
((__t=( t('Common', 'surveyParticipation.footer.actions.prev') ))==null?'':_.escape(__t))+
'</div>\n    <div class="btn btn--survey-submit btn--default '+
((__t=( nextClass ))==null?'':_.escape(__t))+
'">'+
((__t=( nextLabel ))==null?'':_.escape(__t))+
'</div>\n  </div>\n  <div class="survey-footer__pagination">\n    '+
((__t=( current + 1 ))==null?'':_.escape(__t))+
' / '+
((__t=( form.items.length ))==null?'':_.escape(__t))+
'\n  </div>\n';
 } 
__p+='\n';
}
return __p;
};
